import * as React from 'react';
import { SVGProps } from 'react';

const IconDiamondSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 11 11 3 8 0H3L0 3l4.714 6.857L3 3h2.5v8z"
    />
  </svg>
);
export default IconDiamondSizeXs;
